import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/About";
import Vendors from "../pages/Vendors";
import Riders from "../pages/Riders";
import Waitlist from "../pages/Waitlist";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/vendors",
    element: <Vendors />,
  },
  {
    path: "/riders",
    element: <Riders />,
  },
  {
    path: "/waitlist",
    element: <Waitlist />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;